import LoadingSkeletonContainer from 'ComponentLibrary/src/atoms/LoadingSkeleton/LoadingSkeletonContainer'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

export function TaskChangeLogLoader() {
    return (
        <LoadingSkeletonContainer
            loadersPattern={[{ count: 2, height: '32px' }]}
            gap={tokens.SizingSpacing075}
            justifyContent="flex-end"
            padding={`${tokens.SizingSpacing100} 0 ${tokens.SizingSpacing200} 0`}
        />
    )
}
